// @flow
import update from 'immutability-helper';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { scrapUrlApi } from './api';

import type { HTTPError } from '../../error';
import type { ScrappedProduct } from '../../entities';

type ScrapAction = {
  +type: string;
  +error?: HTTPError;
  +url?: string;
  +scrappedProduct?: ScrappedProduct;
};

export type ScrapState = {
  +isScrappingUrl?: boolean;
  +scrappedProduct?: ScrappedProduct;
  +scrapSuccess?: boolean;
  +scrapUrlError?: HTTPError;
};

//Actions
const SCRAP_URL_REQUEST = 'SCRAP_URL_REQUEST';
const SCRAP_URL_SUCCESS = 'SCRAP_URL_SUCCESS';
const SCRAP_URL_ERROR = 'SCRAP_URL_ERROR';
const SCRAP_RESET_STATE = 'SCRAP_RESET_STATE';

//Action creators
export function scrapUrl(url: string): ScrapAction {
  return {
    type: SCRAP_URL_REQUEST,
    url,
  }
}

export function scrapUrlSuccess(scrappedProduct: ScrappedProduct): ScrapAction {
  return {
    type: SCRAP_URL_SUCCESS,
    scrappedProduct,
  }
}

export function scrapUrlErrorFn(error: HTTPError): ScrapAction {
  return {
    type: SCRAP_URL_ERROR,
    error,
  }
}

export function scrapResetState(): ScrapAction {
  return {
    type: SCRAP_RESET_STATE,
  };
}

export const actions = {
  SCRAP_URL_REQUEST,
  SCRAP_URL_SUCCESS,
  SCRAP_URL_ERROR,
  SCRAP_RESET_STATE,
  scrapUrl,
  scrapUrlSuccess,
  scrapUrlErrorFn,
  scrapResetState,
};

export const initialState: ScrapState = {};

// Reducer
export default function reducer(state: ScrapState = initialState,
                                action: ScrapAction): ScrapState {
  switch (action.type) {
    case SCRAP_URL_REQUEST:
      return update(state, {
        isScrappingUrl: { $set: true },
        $unset: ['scrapUrlError', 'scrappedProduct', 'scrapSuccess'],
      });
    case SCRAP_URL_SUCCESS:
      return update(state, {
        // scrappedProduct: { $set: {...action.scrappedProduct, ...detailOptions} },
        scrappedProduct: { $set: action.scrappedProduct },
        scrapSuccess: { $set: true },
        $unset: ['isScrappingUrl'],
      });
    case SCRAP_URL_ERROR:
      return update(state, {
        scrapUrlError: { $set: action.error },
        $unset: ['isScrappingUrl'],
      });
    case SCRAP_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

export function scrapUrlEpic(action$: Observable<ScrapAction>): Observable<ScrapAction> {
  return action$.pipe(
    ofType(SCRAP_URL_REQUEST),
    mergeMap(({ url }) => scrapUrlApi({ url: encodeURI(url) }).pipe(
      map(scrapUrlSuccess),
      catchError((e: HTTPError) => of(scrapUrlErrorFn(e))),
    )),
  );
}



// WEBPACK FOOTER //
// ./src/modules/scrap/duck.js